<template>
    <section v-if="state">
        <ul class="gadget-step-progress mb-4">
            <li :class="{ 'active': state >= $Constants.JOB_STATUS_NEW }">เปิดใบเคลม</li>
            <li :class="{ 'active': state >= $Constants.JOB_STATUS_PENDING }">ตรวจสอบ</li>
            <li :class="{ 'active': state === $Constants.JOB_STATUS_COMPLETE }">ออกใบเคลม</li>
        </ul>
    </section>
</template>

<script>
export default {
    data() {
        return {
            state: null
        }
    },
    props: {
        loadData: Object
    },
    watch: {
        loadData: {
            deep: true,
            handler: function (data) {
                this.state = data.status;
            }
        }
    },
    mounted() {
        this.state = this.$Constants.JOB_STATUS_NEW;
    }
}
</script>